import { t, te, locale } from 'utils/i18n.js'
import I18nT from 'utils/I18nT.js'

// Translations for components.
//
// Templates use the global $t, installed by the plugin below:   {{ $t('app.jobs.title') }}
// A sentence with a link inside uses <i18n-t> (utils/I18nT.js).
// Script code (labels in arrays, notifications, validation) uses the composable:
//
//   const { t } = useI18n()
//   flash.value.show(t('app.jobs.saved'), 'notice')
//
// Same names as vue-i18n on purpose, so moving to that library later would not touch the components.
export function useI18n() {
  return { t, te, locale: locale() }
}

export const i18nPlugin = {
  install(app) {
    app.config.globalProperties.$t = t
    app.config.globalProperties.$te = te
    app.component('I18nT', I18nT)
  },
}
